import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { TRIP_ARRIVAL_INFORMATION } from 'api/query-keys.ts';
import type { TArrivalInformation } from 'api/swagger';

export const useGetArrivalInformation = (tripId: number, options?: { enabled: boolean }) => {
  return useQuery<TArrivalInformation[]>({
    queryKey: [TRIP_ARRIVAL_INFORMATION, tripId],
    queryFn: async () => {
      const { data } = await http.get<TArrivalInformation[]>(`/v1/trips/${tripId}/arrival-information`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    ...options,
  });
};
